import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const isLimit = (e) => e?.response?.status === 402 || e?.response?.data?.detail?.code === "upgrade_required";
export const isMissing = (e) => [404, 405].includes(e?.response?.status);
export const txt = (v) => (v == null || v === false ? "" : typeof v === "string" || typeof v === "number" ? String(v) : Array.isArray(v) ? v.map(txt).filter(Boolean).join(", ") : typeof v === "object" ? txt(v.text ?? v.label ?? v.name ?? v.title ?? v.value ?? v.content ?? "") : String(v));
export const tid = (v) => (v && typeof v === "object" ? String(v.id ?? v.key ?? v.slug ?? txt(v)) : String(v ?? ""));

export const wbError = (e) => {
  if (isLimit(e)) toast("You've used this month's free AI refreshes", { id: "wb-limit", description: "Daily content stays free. Upgrade for unlimited refreshes and companion chats.", action: { label: "Upgrade", onClick: () => { window.location.href = "/upgrade"; } } });
  else toast.error(errMsg(e));
};

export const useWb = (path, { skip = false } = {}) => {
  const [s, setS] = useState({ data: null, loading: !skip, missing: false, error: null });
  const load = useCallback(() => {
    if (!path) return Promise.resolve();
    setS((x) => ({ ...x, loading: true, error: null }));
    return api.get(path).then((r) => setS({ data: r.data, loading: false, missing: false, error: null }))
      .catch((e) => setS({ data: null, loading: false, missing: isMissing(e), error: isMissing(e) ? null : errMsg(e) }));
  }, [path]);
  useEffect(() => { if (!skip) load(); }, [load, skip]);
  return { ...s, reload: load, setData: (d) => setS((x) => ({ ...x, data: typeof d === "function" ? d(x.data) : d })) };
};

export const wbPost = async (path, body, okMsg) => {
  try { const { data } = await api.post(path, body); if (okMsg) toast.success(okMsg); return data; } catch (e) { wbError(e); return null; }
};

export const saveItem = (item) => wbPost("/wellbeing/saved", item, "Saved to My Journal");

export const share = async (text) => {
  try { if (navigator.share) await navigator.share({ text }); else { await navigator.clipboard.writeText(text); toast.success("Copied to clipboard"); } } catch {}
};

export const TARGETS = {
  checkin: "/wellbeing#overview", reflection: "/wellbeing/reflection", wisdom: "/wellbeing/wisdom", value: "/wellbeing/value",
  challenge: "/wellbeing/growth", journal: "/wellbeing/journal", boost: "/wellbeing/boost", progress: "/wellbeing/progress",
  tracker: "/tracker", resume_studio: "/resume-studio", calendar: "/calendar", rest: "/calendar", companion: "/wellbeing/companion",
  mock_interview: "/chat/mock_interview", journeys: "/wellbeing/journeys",
};
export const targetUrl = (t) => TARGETS[t] || "/wellbeing";
